import { Service } from '@roc/feature-app-core';

const url = {
  GET_MESSAGE_CONFIG: '/api/v1/loan/idVerification/getMessageConfig',
  SEND_REQUEST_ID_VERIFICATION_EMAIL: '/api/v1/loan/sendRequestAuthIdVerifEmail',
  FIND_BORROWERS_AND_LEADS_BY_NAME: '/api/v1/loan/oneTool/findBorrowersAndLeadsByName',
  FIND_BORROWERS_BY_NAME: '/api/v1/loan/oneTool/findBorrowersByName',
  GET_BORROWER_BY_ID: '/api/v1/loan/borrower/getBorrowerById',
  SAVE_FINANCIAL_INFORMATION: '/nportal/rest/pub/idVerification/saveFinancialInformation',
  GET_LEAD_BY_ID: '/api/v1/lender/lead/getLeadByIdForUser'
};

export class RequestIdVerificationService extends Service {

  getMessageConfig(host: string, borrowerId: number, lenderId?: number) {
    return this.get(url.GET_MESSAGE_CONFIG, { host, borrowerId, lenderId });
  }

  sendRequestIdVerificationEmail(data) {
    return this.post(url.SEND_REQUEST_ID_VERIFICATION_EMAIL, data);
  }

  findBorrowersAndLeadsByName(name: string, cancelToken?) {
    return this.get(
      url.FIND_BORROWERS_AND_LEADS_BY_NAME,
      { name },
      { disableGlobalLoading: true, cancelToken }
    );
  }

  findBorrowersByName(name: string, cancelToken?) {
    return this.get(
      url.FIND_BORROWERS_BY_NAME,
      { name },
      { disableGlobalLoading: true, cancelToken }
    );
  }

  fetchBorrowerData(borrowerId) {
    return this.get(url.GET_BORROWER_BY_ID, { borrowerId });
  }

  saveFinancialInformation(data) {
    return this.post(url.SAVE_FINANCIAL_INFORMATION, data);
  }

  fetchLeadData(leadId, businessUnit) {
    return this.get(url.GET_LEAD_BY_ID, { leadId, businessUnit });
  }
}
